import { ReactNode } from 'react'

import { clx } from '@/utils/clx'

import { Button } from './button'
import { Heading } from './heading'
import { Text } from './text'

interface EmptyStateProps {
	icon?: ReactNode
	title: string
	description?: ReactNode
	action?: {
		label: string
		onClick: () => void
	}
	className?: string
}

export const EmptyState = ({ icon, title, description, action, className }: EmptyStateProps) => {
	return (
		<div
			className={clx(
				'flex min-h-[400px] flex-col items-center justify-center gap-4 rounded-lg bg-ui-bg-subtle p-8 text-center',
				className
			)}
		>
			{icon && <div className='text-ui-fg-muted'>{icon}</div>}
			<div className='flex flex-col items-center gap-2'>
				<Heading level='h2' className='text-ui-fg-base'>
					{title}
				</Heading>
				{description && (
					<Text className='text-ui-fg-subtle' size='small'>
						{description}
					</Text>
				)}
			</div>
			{action && (
				<Button onClick={action.onClick} variant='primary' className='mt-2'>
					{action.label}
				</Button>
			)}
		</div>
	)
}
